// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pSti","top":"styles_top__1Cm_j","left":"styles_left__3nWby","description":"styles_description__3kPBq"};